import React, { Fragment, useCallback, useState } from 'react'
import './DialList.css'
import NotCalled from '../../../../assets/ringTypes/NotCalled.png'
import CallBackCall from '../../../../assets/ringTypes/CallBackCall.png'
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { RiContactsLine, RiUserAddLine } from "react-icons/ri";
import { Menu, MenuItem } from '@mui/material';

const DialList = (props) => {
    const { crmContact, crmSupportChannel } = props
    const [t] = useTranslation('common')
    const [tcrm] = useTranslation('crm')
    const navigate = useNavigate();
    const appAccess = props.appAccess
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const openDropdown = Boolean(menuAnchorEl);
    let callStatusHeb = null
    let icon = NotCalled
    if (props.CallStatus === 'notactive') callStatusHeb = t('Not active')
    if (props.CallStatus === 'waiting') callStatusHeb = t('Waiting')
    if (props.CallStatus === 'postponed') callStatusHeb = t('Rejected')
    if (props.CallStatus === 'bore') callStatusHeb = t('Snooze')
    if (props.projectDesc) icon = CallBackCall
    let cardColor = 'row card chatCard'
    if (!props.selectMultipleBtnClicked && (props.dialItemSelected._id === props._id && props.dialItemSelected.telephone === props.telephone)) {
        cardColor = 'row card chatCard chatCardOnSelect'
    }
    else if (props.selectMultipleBtnClicked && props.isDialListMultiSelected) {
        cardColor = 'row card chatCard chatCardOnSelect'
    }
    let title = null
    if (crmSupportChannel && crmContact?.crmName) {
        title = crmContact.crmName
    }
    else if (props.name) {
        title = props.name;
    }
    else {
        title = props.telephone.replace('+972', '0');
    }
    // if (!props.name) {
    //     title = props.telephone.replace('+972', '0');
    // }
    // else {
    //     title = props.name;
    // }
    const OnNewConvChannelSelected = props.OnNewConvChannelSelected
    const onNewConvName = props.onNewConvName
    const OnNewConvClicked = props.OnNewConvClicked
    const onChannelSelect = useCallback((channelId, msgType) => {
        OnNewConvChannelSelected(msgType)
        onNewConvName(channelId)
        setTimeout(() => OnNewConvClicked(), 0)

    }, [OnNewConvClicked, onNewConvName, OnNewConvChannelSelected])

    const handleMenuOpen = (event) => {
        event.stopPropagation();
        setMenuAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => setMenuAnchorEl(null);

    const openNewLead = useCallback(() => {
        navigate(`/crm/lead/create?mainPhone=${props.telephone}`);
        handleMenuClose();
    }, [navigate, props.telephone]);

    // const openContact = useCallback(() => {
    //     navigate(`/crm/contact/records/${crmContact?._id}`)
    // }, [crmContact])
    const openCrmRecord = useCallback(() => {
        if (!crmContact) return;
        const route = crmContact.moduleType === 'Lead' ? 'lead' : 'contact';
        navigate(`/crm/${route}/records/${crmContact._id}`);
    }, [crmContact]);

    const openNewContact = useCallback(() => {
        navigate(`/crm/contact/create?mainPhone=${props.telephone}`)
    }, [props.telephone])

    return (
        <Fragment>
            <div className={cardColor} onClick={props.OnDialItemSelected}>

                <div className='col-10 col-md-9 costContactsTextCol'>
                    <div className='card-body chatCardBody'>
                        <p className='mutedP'>{props.startTime}</p>
                        <p className='contactCardTitle'>{title}{props.projectDesc && <i title={t('Callback from') + props.projectDesc} className="fas fa-voicemail cusVoiceMailDialList" />} </p>
                        <p className='dialListCardText'> {props.desc} <span className='callStatus'>{callStatusHeb}</span></p>
                        <div className='containerDialList'>
                            <div className='dialListItem_channelsPanel'>
                                {appAccess !== 'DIALER' && <i className="fab fa-whatsapp-square dialListItem_channelsPanel_whatsapp" onClick={() => onChannelSelect(props.telephone.split('_')[0], 'whatsapp')} />}
                                {appAccess !== 'DIALER' && props.companyDetails.sms && <i className="fas fa-sms dialListItem_channelsPanel_sms" onClick={() => onChannelSelect(props.telephone.split('_')[0], 'sms')} />}
                            </div>
                            <div>
                                {!props.companyDetails.supportCRM && (
                                    props.isContactIdAvailabileDialList?._id ?
                                        <i className="fa-regular fa-pen-to-square chatContact_channelsPanel_contactList" onClick={() => props.onContactListBtnClicked('edit', 'DIALLIST')} />
                                        :
                                        <i className="fa-solid fa-plus chatContact_channelsPanel_contactList" onClick={() => props.onContactListBtnClicked('add', 'DIALLIST')} />
                                )}
                                {
                                    crmSupportChannel && crmContact &&
                                    (
                                        <i className="fa-regular fa-pen-to-square chatContact_channelsPanel_contactList" onClick={openCrmRecord} />
                                    )
                                }
                                {/* {
                                    crmSupportChannel && !crmContact &&
                                    (
                                        <i className="fa-solid fa-plus chatContact_channelsPanel_contactList" onClick={() => openNewContact()} />
                                    )
                                } */}
                                {crmSupportChannel && !crmContact && (
                                    <>
                                        <i
                                            className="fa-solid fa-plus chatContact_channelsPanel_contactList"
                                            style={{ cursor: 'pointer' }}
                                            onClick={handleMenuOpen}
                                        />
                                        <Menu
                                            anchorEl={menuAnchorEl}
                                            open={openDropdown}
                                            onClose={handleMenuClose}
                                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                            sx={{ '& .MuiPaper-root': { minWidth: 160 }, direction: 'ltr' }}
                                        >
                                            <MenuItem onClick={() => { openNewContact(); handleMenuClose(); }}>
                                                <RiContactsLine style={{ marginRight: 8 }} />
                                                {tcrm('New Contact')}
                                            </MenuItem>
                                            <MenuItem onClick={openNewLead}>
                                                <RiUserAddLine style={{ marginRight: 8 }} />
                                                {tcrm('New Lead')}
                                            </MenuItem>
                                        </Menu>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-2 col-md-3 costContactsCol'>
                    <div className='dialListIcon'>
                        <img src={icon} onClick={props.CallBtClicked} className='dialListImg' alt='...' />
                    </div>
                </div>
            </div>
            <hr className="dividingLineBetChats" />
        </Fragment>
    )
};

export default DialList;